export default __webpack_public_path__ + "0dbba3bfb432ee5d6861a05f999da3f8.png";